import { render, staticRenderFns } from "./LikeList.vue?vue&type=template&id=6097d365"
import script from "./LikeList.vue?vue&type=script&lang=js"
export * from "./LikeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports